var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEstablishmentLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 22,
    viewBox: "0 0 117 106",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108.5 61C108.5 61.2761 108.724 61.5 109 61.5C109.276 61.5 109.5 61.2761 109.5 61H108.5ZM108.5 33V61H109.5V33H108.5Z",
    fill: "#8A99F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3092 53.2073C22.1426 53.1144 21.9375 53.2349 21.9375 53.4257V81.5385C21.9375 81.5385 21.9375 106 58.5 106C95.0625 106 95.0625 81.5385 95.0625 81.5385V53.4257C95.0625 53.2349 94.8574 53.1144 94.6908 53.2073L58.987 73.1132C58.6843 73.2819 58.3158 73.2819 58.013 73.1132L22.3092 53.2073Z",
    fill: "#8A99F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.786743 32.0629L58.2572 0.134901C58.4082 0.0510057 58.5918 0.0510061 58.7428 0.134901L116.213 32.0629C116.556 32.2534 116.556 32.7466 116.213 32.9371L58.7428 64.8651C58.5918 64.949 58.4082 64.949 58.2572 64.8651L0.786742 32.9371C0.443837 32.7466 0.443838 32.2534 0.786743 32.0629Z",
    fill: "#8A99F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstablishmentLogo);
export default __webpack_public_path__ + "static/media/establishmentLogo.8f55402f8dba53dcbb29466f9379eaf6.svg";
export { ForwardRef as ReactComponent };